<template>
  <b-modal
    id="addMultipleDocumentModal"
    size="lg"
    ok-only
    ok-title="Chiudi"
    ok-variant="-transparent"
    header-bg-variant="lisaweb"
    no-close-on-esc
    no-close-on-backdrop
    @hidden="resetModalData"
  >
    <template #modal-header="{ cancel }">
      <div slot="modal-title" class="modal-title">
        <b-icon icon="file-earmark"></b-icon>
        <span>Carica uno o più documenti</span>
      </div>
      <button
        type="button"
        class="close"
        title="Chiudi"
        data-dismiss="modal"
        @click="
          cancel();
          close();
        "
      >
        <base-icon name="close" width="14" height="14"/>
      </button>
    </template>
    <validation-observer ref="observer2" v-slot="{ handleSubmit, invalid }">
      <b-form @submit.prevent="">
        <div class="form-card-wrapper mt-2">
        <b-card header-tag="header">
          <template #header>
            <b>Carica uno o più documenti</b>
          </template>
          <b-card-text>
            <b-row class="mb-4">
              <div class="form-group" style="grid-column: span 2">
                <base-form-file
                  v-model="files"
                  vid="base_form_file"
                  name="Carica File"
                  label="Carica File"
                  accept=".doc, .docx, .pdf, .odt, .png, .jpg, .jpeg, .gz, .txt, .zip, .xls, .xlsx, .p7m, .eml, .msg"
                  :rules="{ required: true }"
                  multiple
                ></base-form-file>
              </div>
              <div class="form-group mt-4">
                <b-button
                  class="btn--smaller"
                  style="height: 30px;"
                  size="sm"
                  variant="lisaweb"
                  @click="clearFile"
                  :disabled="!documentsToUpload.length"
                  title="Cancella File"
                >
                  Cancella File
                </b-button>
              </div>
            </b-row>
            <div
              v-for="(document, index) in documentsToUpload"
              :key="document.key"
              class="border rounded p-3 mb-3"
            >
              <b-row>
                <div class="form-group mb-2">
                  <strong>{{ document.file.name }}</strong>
                </div>
              </b-row>

              <b-row style="grid-template-columns: repeat(3, 1fr)">
                <div class="form-group">
                  <base-input
                    :vid="`title_${index}`"
                    :name="`${beFormCreate.title.label} ${index + 1}`"
                    :label="beFormCreate.title.label"
                    v-model="document.title"
                    :placeholder="beFormCreate.title.label"
                    :rules="getRules('title', 'document')"
                  />
                </div>

                <div class="form-group">
                  <base-select
                    :vid="`document_type_${index}`"
                    :name="`${beFormCreate.document_type.label} ${index + 1}`"
                    :label="beFormCreate.document_type.label"
                    v-model="document.document_type"
                    :options="beFormCreate.document_type.options"
                    :rules="getRules('document_type', 'document')"
                  />
                  <small class="form-text text-muted">
                    Precompilato con "Generico". <br />
                    Puoi modificarlo prima del caricamento.
                  </small>
                </div>

                <div class="form-group">
                  <base-textarea
                    :vid="`note_${index}`"
                    :name="`${beFormCreate.note.label} ${index + 1}`"
                    :label="beFormCreate.note.label"
                    v-model="document.note"
                    placeholder="Inserisci una nota"
                    :rules="getRules('note', 'document')"
                  />
                </div>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
        </div>
        <b-button
          type="button"
          @click="handleSubmit(upload)"
          :disabled="invalid || !documentsToUpload.length"
          variant="primary"
          size="sm"
          class="mt-3 float-right"
        >
          Carica
        </b-button>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
<script>
import BaseTextarea from "@/components/form/BaseTextarea";
import BaseSelect from "@/components/form/BaseSelect";
import BaseInput from "@/components/form/BaseInput";
import BaseFormFile from "@/components/form/BaseFormFile";
import FormMixin from "@/mixins/FormMixin";
import { mapGetters } from "vuex";
import BaseIcon from "@/components/BaseIcon";

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        title: null,
        document_type: null,
        note: null,
        user_id: null,
        source_type: 0,
      },
      files: [],
      documentsToUpload: [],
    };
  },
  components: {
    BaseIcon,
    BaseInput,
    BaseSelect,
    BaseTextarea,
    BaseFormFile,
  },
  watch: {
    files(newFiles) {
      const files = this.normalizeFiles(newFiles);

      const previousByKey = this.documentsToUpload.reduce((acc, document) => {
        acc[document.key] = document;
        return acc;
      }, {});

      this.documentsToUpload = files.map((file) => {
        const key = this.fileKey(file);
        const previous = previousByKey[key];

        return previous
          ? {
            ...previous,
            file,
          }
          : {
            key,
            file,
            title: this.getFileNameWithoutExtension(file.name),
            document_type: this.getDefaultDocumentType(),
            note: null,
          };
      });
    },
  },
  methods: {
    getDefaultDocumentType() {
      const options =
        this.beFormCreate &&
        this.beFormCreate.document_type &&
        this.beFormCreate.document_type.options
          ? this.beFormCreate.document_type.options
          : [];

      const genericOption = options.find((option) => {
        const label = String(
          option.label ||
          option.text ||
          option.name ||
          option.description ||
          option.title ||
          "",
        ).toLowerCase();

        return label === "generico";
      });

      if (!genericOption) {
        return null;
      }

      if (genericOption.value !== undefined) {
        return genericOption.value;
      }

      if (genericOption.id !== undefined) {
        return genericOption.id;
      }

      return genericOption;
    },
    normalizeFiles(files) {
      if (!files) {
        return [];
      }

      return Array.isArray(files) ? files : Array.from(files);
    },
    fileKey(file) {
      return `${file.name}_${file.size}_${file.lastModified}`;
    },

    getFileNameWithoutExtension(fileName) {
      return fileName.replace(/\.[^/.]+$/, "");
    },
    clearFile() {
      this.files = [];
      this.documentsToUpload = [];
    },
    upload() {
      const missingDocumentType = this.documentsToUpload.find((document) =>
        this.isEmpty(this.getSelectValue(document.document_type)),
      );

      if (missingDocumentType) {
        this.$showSnackbar({
          preset: "error",
          text: `Seleziona il tipo documento per "${missingDocumentType.file.name}"`,
        });

        return;
      }

      const forms = this.documentsToUpload.map((document) => {
        const formData = new FormData();

        // formData.append("file", document.file);
        formData.append("file", document.file, document.file.name);
        formData.append(
          "document_type",
          this.getSelectValue(document.document_type),
        );
        formData.append("title", document.title);
        formData.append("source_type", this.form.source_type);

        if (document.note && document.note.trim()) {
          formData.append("note", document.note.trim());
        }

        return formData;
      });

      this.$emit("upload", forms);
      this.$bvModal.hide("addMultipleDocumentModal");
      this.resetModalData();
    },
    close() {
      this.$bvModal.hide("addMultipleDocumentModal");
      this.resetModalData();
    },
    resetModalData() {
      this.files = [];
      this.documentsToUpload = [];
    },
    getSelectValue(value) {
      if (value && typeof value === "object" && value.value !== undefined) {
        return value.value;
      }

      return value;
    },
    isEmpty(value) {
      return value === null || value === undefined || value === "";
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  beforeMount() {
    this.beRules["document"] = this.beRulesCreate;
    this.form.user_id = this.user.id;
  },
  props: {
    beRulesCreate: {
      type: Object,
      default() {
        return {};
      },
    },
    beFormCreate: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(tbody) {
  border-top: 0px !important;
}
:deep(table td) {
  border-top: 0px solid var(--color-border);
}
</style>